import getCartAction from "./getCartAction";
import processOrderRequest from "../requests/processOrderRequest";

const reopenOrderAction = async (session, reopenID, onReopened) => {

    const reOpen = await processOrderRequest(session, reopenID, 'RE');
    const success = reOpen?.value?.data?.DocStatus?.id === 'IP';
    if(!success) {
        throw new Error("Failed to re-open order");
    }

    if(onReopened) {
        onReopened();
    }
    return await getCartAction(session);
}

export default reopenOrderAction;